// Promo-modals

( function($, waTheme) {

    var FeedbackModal = (function ($) {

        FeedbackModal = function (options) {
            var that = this;

            // DOM
            that.$wrapper = options['$wrapper'];

            // VARS
            // that.options = that.$wrapper.data("modal");

            // DYNAMIC VARS

            // EVENTS
            that.bindEvents();
            // that.init();
        };

        FeedbackModal.prototype.bindEvents = function () {
            var that = this;

            console.log("show modal");

            $(document).on("click", `.sellerFeedbackModalShow, a[href="#sellerFeedbackModalShow"]`, function () {
                that.$wrapper.modal("show");
            });
        }

        return FeedbackModal;

    })($);

    waTheme.init.site.FeedbackModal = FeedbackModal;

    var $feedbackModal = $("#sellerFeedbackModal");
    if ($feedbackModal.length) {
        new window.waTheme.init.site.FeedbackModal({
            $wrapper: $feedbackModal
        });
    }

})(jQuery, window.waTheme);